import type { ReactNode } from 'react';
import React, { createContext, useContext } from 'react';
import type { BiLogger } from '@wix/cli-telemetry';

const BiContext = createContext<BiLogger | null>(null);

export const BiProvider = function ({
  children,
  value: biLogger,
}: {
  children: ReactNode;
  value: BiLogger;
}) {
  return <BiContext.Provider value={biLogger}>{children}</BiContext.Provider>;
};

export const useBiLogger = (): BiLogger => {
  const context = useContext(BiContext);

  if (context == null) {
    throw new Error('useBiLogger() cannot be used without an <BiProvider>');
  }

  return context;
};
